module.exports = __webpack_public_path__ + "img/block2.984be933.png";